<template>
	<div
		v-if="ready"
		class="container-fluid"
	>

		<div class="row center">
			<div class="col-lg-12">
				<h1 class="main-content-title">
					<div class="flex-start">
						<el-button
							@click="back()"
							icon="el-icon-back"
							size="mini"
							circle
							style="margin-right: 10px"
						/>
						<div class="truncate-title">
							{{ title }}
						</div>
					</div>
					<div class="main-content-title-buttons">
						<el-button
							@click="openAssignDialog()"
							type="primary"
							plain
						>
							{{ translations.labels.assignToDevice }}
						</el-button>
					</div>
				</h1>
			</div>
		</div>

		<div class="row center">
			<div class="col-lg-12">
				<div class="box">
					<div class="box-body">
						<div class="row">
							<div class="col-lg-12">

								<div class="schedule">

									<div class="schedule-navigation">
										<div class="schedule-navigation-title">
											<i class="el-icon-date margin-right-5" />
											{{ makeTitleDate(week[0].dateTime) }} - {{ makeTitleDate(week[6].dateTime) }}
										</div>
										<el-button-group>
											<el-button
												@click="setWeek('prev')"
												type="primary"
												size="small"
												icon="el-icon-arrow-left"
												plain

											/>
											<el-button
												@click="setWeek('next')"
												type="primary"
												size="small"
												icon="el-icon-arrow-right"
												plain
											/>
										</el-button-group>
									</div>

									<div class="schedule-head">
										<div class="schedule-head-day"></div>
										<div v-for="(day, index) in week" :key="index" class="schedule-head-day">
											{{ makeHeadingDateTime(day.dateTime) }}
										</div>
									</div>

									<div class="schedule-body">
										<div class="schedule-body-day">
											<div
												v-for="(item, index) in hours"
												:key="index"
												class="schedule-body-day-cell"
											>
												<div class="schedule-body-day-cell-hour">
													{{ item !== '00:00' ? item : null }}
												</div>
											</div>
										</div>
										<div
											v-for="(day, d) in week"
											:key="d"
											class="schedule-body-day"
										>
											<div
												v-for="(hour, h) in day.hours"
												:key="h"
												class="schedule-body-day-cell"
												:class="day.active ? 'active' : 'disabled'"
												@click="day.active ? openEntryDialog(day.startDate, hour, findEntry(day.startDate, hour)) : null"
											>
												<div v-if="findEntry(day.startDate, hour)" class="schedule-body-day-cell-wrap">
													<div
														class="schedule-body-day-cell-entry"
														:style="{ 'height' : cellHeight(findEntry(day.startDate, hour)), 'background-color' : findPresentation(findEntry(day.startDate, hour).presentationId).settings.color }"
													>
														<div class="schedule-body-day-cell-entry-title">
															{{ findPresentation(findEntry(day.startDate, hour).presentationId).title }}
														</div>
														<div class="schedule-body-day-cell-entry-time">
															{{ findEntry(day.startDate, hour).startTime }} - {{ findEntry(day.startDate, hour).endTime }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- entry dialog -->
		<el-dialog
			:title="dialog.title"
			:visible.sync="dialog.entry"
			:show-close="false"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			@opened="openedEntryDialog"
			@closed="closedEntryDialog"
			width="600px"
		>
			<el-form
				@submit.prevent.native="submitForm('entryForm')"
				:model="entry"
				:rules="entryRules"
				ref="entryForm"
			>
				<div class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.presentation }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<el-form-item prop="presentationId">
							<el-select
								v-model="entry.presentationId"
								:placeholder="translations.labels.selectPresentation"
								class="wide"
							>
								<el-option
									v-for="(item, index) in presentations"
									:key="index"
									:label="item.title"
									:value="item.id"
								>
									<div class="flex-start">
										<span
											class="presentation-color"
											:style="{ 'background-color': item.settings.color }"
										/>
										{{ item.title }}
									</div>
								</el-option>
							</el-select>
							<div class="align-right">
								<router-link :to="`/presentations/${entry.presentationId}`">
									{{ translations.labels.editPresentation }}
								</router-link>
							</div>
						</el-form-item>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.startDate }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<el-form-item prop="startDate">
							<el-date-picker
								v-model="entry.startDate"
								:placeholder="translations.labels.pickDay"
								:picker-options="startDatePickerOptions"
								value-format="yyyy-MM-dd"
								type="date"
							/>
						</el-form-item>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.time }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<div class="row">
							<div class="col-lg-6 col-sm-12">
								<el-form-item prop="startTime">
									<el-select
										v-model="entry.startTime"
										:placeholder="translations.labels.startTime"
										clearable
									>
										<template slot="prefix">
											<i class="el-icon-time margin-left-5" />
										</template>
										<el-option
											v-for="(hour, index) in hours"
											:key="index"
											:label="hour"
											:value="hour"
										/>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-lg-6 col-sm-12">
								<el-form-item prop="endTime">
									<el-select
										v-model="entry.endTime"
										:placeholder="translations.labels.endTime"
										clearable
									>
										<template slot="prefix">
											<i class="el-icon-time margin-left-5" />
										</template>
										<el-option
											v-for="(hour, index) in endHours"
											:key="index"
											:label="hour"
											:value="hour"
										/>
										<el-option
											label="24:00"
											value="24:00"
										/>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.repetition }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<el-form-item prop="frequencyCode">
							<el-select
								v-model="entry.frequencyCode"
								:placeholder="translations.labels.pleaseSelect"
								class="wide"
							>
								<el-option
									v-for="(item, index) in frequencyCodesList"
									:key="`freq-${index}`"
									:label="item"
									:value="index"
								/>
							</el-select>
						</el-form-item>
					</div>
				</div>
				<div v-if="entry.frequencyCode !== 0 && entry.frequencyCode !== null" class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.duration }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<el-form-item prop="duration">
							<el-select
								v-model="entry.duration"
								:placeholder="translations.labels.pleaseSelect"
								class="wide"
							>
								<el-option
									v-for="(item, index) in durationList"
									:key="`duration-${index}`"
									:label="item"
									:value="index"
								/>
							</el-select>
						</el-form-item>
					</div>
				</div>
				<div v-if="entry.duration === 1"  class="row">
					<div class="col-lg-3 col-sm-12">
						<label class="required">
							{{ translations.labels.endDate }}
						</label>
					</div>
					<div class="col-lg-9 col-sm-12">
						<el-form-item prop="endDate">
							<el-date-picker
								v-model="entry.endDate"
								:placeholder="translations.labels.pickDay"
								:picker-options="endDatePickerOptions"
								value-format="yyyy-MM-dd"
								type="date"
							/>
						</el-form-item>
					</div>
				</div>
				<div v-if="dialog.error" class="row margin-bottom-20">
					<div class="col-lg-9 col-lg-offset-3 col-sm-12 col-md-offset-0">
						<el-alert
							:title="translations.messages.warningNotPossibleTimeSlot"
							:closable="false"
							type="error"
							show-icon
						/>
					</div>
				</div>
				<div class="flex-between margin-top-2">
					<el-popconfirm
						v-if="existingEntry"
						@confirm="ajaxDeleteEntry()"
						:title="translations.labels.areYouSureToDelete"
						confirm-button-text="OK"
						:cancel-button-text="translations.labels.noCancel"
						hide-icon
					>
						<el-button
							:loading="processing.delete"
							slot="reference"
							type="danger"
							plain
						>
							{{ translations.labels.delete }}
						</el-button>
					</el-popconfirm>
					<span v-else></span>
					<div>
						<el-button
							:loading="processing.update"
							native-type="submit"
							type="primary"
							plain
						>
							<template v-if="existingEntry">
								{{ translations.labels.saveChanges }}
							</template>
							<template v-else>
								{{ translations.labels.addEntry }}
							</template>
						</el-button>
						<el-button
							@click="closeEntryDialog()"
							plain
						>
							{{ translations.labels.cancel }}
						</el-button>
					</div>
				</div>
			</el-form>
		</el-dialog>
		<!-- /entry dialog -->

		<!-- assign -->
		<AssignToDevice
			:current="schedule"
			:devices="devices"
			:processing="processing.assign"
			:show="dialog.assign"
			:title="translations.labels.assignSchedule"
			type="schedule"
			:warning="translations.messages.warningAssignSchedule"
			:warningApply="translations.messages.warningAppliedImmediately"
		/>
		<!-- /assign -->

	</div>
</template>

<script>
import { _getSchedule, _updateSchedule } from '@/services/api/schedules'
import { _getAllPresentations } from '@/services/api/presentations'
import { _getAllDevices, _assignToDevice } from '@/services/api/devices'

import { EventBus } from '@/services/event-bus'
import arrayFromString from '@/services/mixins/arrayFromString'
import generateUuid from '@/services/mixins/generateUuid'
import sortArray from '@/services/mixins/sortArray'

export default {
	name: 'ScheduleSetup',
	metaInfo () {
		return {
			title: this.translations.labels.setupSchedule
		}
	},
	mixins: [
		arrayFromString,
		generateUuid,
		sortArray
	],
	components: {
		AssignToDevice: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Dialog/AssignToDevice')
	},
	data () {
		const self = this
		const checkStartTime = (rule, value, callback) => {
			if (this.entry.startTime && this.entry.endTime) {
				const startTime = this.extractHour(this.entry.startTime)
				const endTime = this.extractHour(this.entry.endTime)
				if (startTime > endTime) {
					callback(new Error(this.translations.messages.warningStartTimeWrong))
				}
				callback()
			} else {
				callback(new Error(this.translations.messages.enterStartTime))
			}
		}
		const checkEndDate = (rule, value, callback) => {
			if (this.entry.duration > 0) {
				if (this.entry.endDate === null) {
					callback(new Error(this.translations.messages.enterEndTime))
				}
				callback()
			} else {
				callback()
			}
		}
		return {
			defaultPeriod: 180,
			devices: [],
			dialog: {
				entry: false,
				title: null,
				error: false,
				assign: false
			},
			endHours: [],
			entry: {
				id: null,
				presentationId: null,
				startDate: null,
				startTime: null,
				endDate: null,
				endTime: null,
				frequencyCode: null,
				duration: null,
				timeZone: null
			},
			entryRules: {
				presentationId: [
					{ required: true, message: this.$store.state.translations.messages.enterChoosePresentation, trigger: 'blur' }
				],
				startDate: [
					{ required: true, message: this.$store.state.translations.messages.enterStartDate, trigger: 'blur' }
				],
				startTime: [
					{ validator: checkStartTime, trigger: 'blur' }
				],
				endDate: [
					{ validator: checkEndDate, trigger: 'blur' }
				],
				endTime: [
					{ required: true, message: this.$store.state.translations.messages.enterEndDate, trigger: 'blur' }
				],
				frequencyCode: [
					{ required: true, message: this.$store.state.translations.messages.enterChooseFrequency, trigger: 'blur' }
				],
				duration: [
					{ required: true, message: this.$store.state.translations.messages.enterChooseDuration, trigger: 'blur' }
				]
			},
			height: 38,
			hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
			endDatePickerOptions: {
				disabledDate: (date) => {
					let temp = new Date()
					return date < temp.setDate(temp.getDate() - 1) || date > temp.setDate(temp.getDate() + 180)
				},
				shortcuts: [
					{
						text: self.$store.state.translations.labels.oneWeek,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setDate(date.getDate() + 7)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.twoWeeks,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setDate(date.getDate() + 14)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.threeWeeks,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setDate(date.getDate() + 21)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.oneMonth,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 1)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.twoMonths,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 2)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.threeMonths,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 3)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.sixMonths,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 6)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.nineMonths,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 9)
							picker.$emit('pick', date)
						}
					},
					{
						text: self.$store.state.translations.labels.oneYear,
						onClick(picker) {
							const date = new Date(self.entry.startDate)
							date.setMonth(date.getMonth() + 12)
							picker.$emit('pick', date)
						}
					}
				]
			},
			existingEntry: false,
			months: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
			processing: {
				delete: false,
				update: false,
				assign: false
			},
			presentations: [],
			scheduleTemp: {},
			startDatePickerOptions: {
				disabledDate: (date) => {
					let temp = new Date()
					return date < temp.setDate(temp.getDate() - 1) || date > temp.setDate(temp.getDate() + 180)
				}
			},
			tempEntry: {},
			timeZone: null,
			title: null,
			week: [],
			weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
		}
	},
	computed: {
		frequencyCodesList () {
			return this.arrayFromString(this.translations.labels.frequenciesList)
		},
		durationList () {
			return this.arrayFromString(this.translations.labels.durationList)
		}
	},
	watch: {
		entry: {
			deep: true,
			handler() {
				this.dialog.error = false
			}
		},
		'entry.frequencyCode' () {
			if (this.entry.frequencyCode === 0) {
				this.entry.duration = null
				this.entry.endDate = null
			}
		},
		'entry.duration' () {
			if (this.entry.duration === 0) {
				this.entry.endDate = null
			}
		},
		'entry.startTime' () {
			if (this.entry.startTime) {
				this.endHours = this.hours.slice(this.extractHour(this.entry.startTime) + 1)
			}
		}
	},
	created () {
		this.objectLength(this.userTeam) ? this.ajaxLoadData() : this.redirectTo('/team/fallback')
	},
	mounted () {
		this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
		EventBus.$on('close-assign', () => this.closeAssignDialog())
		EventBus.$on('submit-assign', (data) => this.ajaxAssignSchedule(data))
	},
	destroyed () {
		EventBus.$off('close-assign')
		EventBus.$off('submit-assign')
    },
	methods: {

		ajaxLoadData () {
			this.ajaxLoadSchedule()
			this.ajaxLoadDevices()
		},
		ajaxLoadDevices () {
			_getAllDevices()
				.then(response => {
					this.devices = response.length ? this.sortArray(response, 'title', 'asc') : []
				})
		},
		ajaxLoadSchedule () {
			_getSchedule(this.$route.params.id)
				.then(response => {
					this.schedule = response
					this.title = this.schedule.title
					this.ajaxLoadPresentations()
					this.setWeek()
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage( this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
					}, 200)
				})
		},
		ajaxLoadPresentations () {
			_getAllPresentations()
				.then(response => {
					const temp = response.filter(item => item.settings.resolution === this.schedule.settings.resolution)
					this.presentations = this.sortArray(temp, 'title', 'asc')
					this.removeLoader()
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage( this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
						this.$store.dispatch('setLoading', false)
						this.$store.dispatch('setReady', true)
					}, 200)
				})
		},
		ajaxUpdateEntry () {

			this.processing.update = true
			this.scheduleTemp = this.clone(this.schedule)

			if (this.existingEntry) {
				const entryIndex = this.scheduleTemp.calendarEntries.findIndex(item => item.id === this.entry.id)
				if (entryIndex !== -1) {
					this.scheduleTemp.calendarEntries.splice(entryIndex, 1)
				}
			}
			this.scheduleTemp.calendarEntries.push(this.entry)

			_updateSchedule(this.scheduleTemp)
				.then(() => {
					this.schedule = this.clone(this.scheduleTemp)
					this.scheduleTemp = {}
					setTimeout (() => {
						this.displayMessage(this.translations.messages.successUpdateEntry, 'success')
						this.closeEntryDialog()
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					this.scheduleTemp = {}
					setTimeout (() => {
						this.processing.update = false
						this.displayMessage( this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
					}, 200)
				})
		},
		ajaxDeleteEntry () {

			this.processing.delete = true
			this.scheduleTemp = this.clone(this.schedule)

			const entryIndex = this.scheduleTemp.calendarEntries.findIndex(item => item.id === this.entry.id)
			if (entryIndex !== -1) {
				this.scheduleTemp.calendarEntries.splice(entryIndex, 1)
			}

			_updateSchedule(this.scheduleTemp)
				.then(() => {
					this.schedule = this.clone(this.scheduleTemp)
					this.scheduleTemp = {}
					setTimeout (() => {
						this.displayMessage(this.translations.messages.successDeleteEntry, 'success')
						this.closeEntryDialog()
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					this.scheduleTemp = {}
					setTimeout (() => {
						this.displayMessage( this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
						this.processing.delete
					}, 200)
				})
		},
		ajaxAssignSchedule (data) {
			this.processing.assign = true
			_assignToDevice(data)
				.then(() => {
					this.ajaxLoadData()
					setTimeout (() => {
						this.closeAssignDialog()
						this.displayMessage( this.translations.messages.successAssignSchedule, 'success')
						this.processing.assign = false
					}, 200)
				})
				.catch(error => {
					const errorCode = error.response.data.status
					setTimeout (() => {
						this.displayMessage( this.translations.statusCodes[errorCode] ? this.translations.statusCodes[errorCode] : this.translations.statusCodes['default'], 'error')
						this.processing.assign = false
					}, 200)
				})
		},

		submitForm (form) {
			this.$refs[form].validate((valid) => {
				if (valid && form === 'entryForm') {
					this.checkEntry()
				}
			})
		},
		setWeek (value) {

			const today = new Date()
			let startDate = new Date()

			if (this.week.length) {
				const temp = new Date(this.week[0].dateTime)
				if (value === 'prev') {
					startDate = new Date(temp.setDate(temp.getDate() - 1))
				} else {
					startDate = new Date(temp.setDate(temp.getDate() + 1))
				}
			}

			this.week = []

			for(let i = 0; i <= 6; i++) {

				let currentDate = new Date(startDate)
				currentDate.setDate(startDate.getDate() + i)

				this.week.push(
					{
						active: currentDate.setHours(0,0,0,0) >= today.setHours(0,0,0,0),
						dateTime: currentDate,
						startDate: this.calculateDate(currentDate),
						hours: this.clone(this.hours)
					}
				)

			}

		},
		makeTitleDate (value) {
			if (value) {
				const temp = new Date(value)
				return temp.getDate() + ' ' + this.convertMonth(temp.getMonth()) + ' ' + temp.getFullYear()
			}
		},
		makeHeadingDateTime (value) {
			if (value) {
				const temp = new Date(value)
				return this.convertDay(temp.getDay()) + ', ' + temp.getDate() + ' ' + this.convertMonth(temp.getMonth())
			}
		},
		convertMonth (monthIndex) {
			return this.months[monthIndex]
		},
		convertDay (dayIndex) {
			return this.weekdays[dayIndex]
		},
		calculateDate (date) {
			if (date) {
				const d = new Date(date)
				let month = '' + (d.getMonth() + 1)
				let day = '' + d.getDate()
				let year = d.getFullYear()
				if (month.length < 2) {
					month = '0' + month
				}
				if (day.length < 2) {
					day = '0' + day
				}
				return [year, month, day].join('-')
			}
		},
		extractHour (value) {
			const temp = value.split(':')
			const hour = temp[0]
			return hour === '00' ? 0 : parseInt(hour.replace(/^0+/, ''))
		},
		cellHeight (entry) {
			const startTime = this.extractHour(entry.startTime)
			const endTime = this.extractHour(entry.endTime)
			return (endTime - startTime) * this.height + 'px'
		},
		openEntryDialog (date, hour, entry) {

			if (this.isTeamViewer) {
				return false
			}

			this.dialog.entry = true
			this.dialog.title = 'Add entry'

			if (entry) {

				this.entry = {
					id: entry.id,
					presentationId: entry.presentationId,
					startDate: entry.startDate,
					startTime: entry.startTime,
					endTime: entry.endTime,
					frequencyCode: entry.frequencyCode,
					duration: entry.duration,
					endDate: entry.endDate,
					timeZone: this.timeZone
				}

				this.dialog.title = 'Edit entry'
				this.existingEntry = true

			} else {

				this.entry = {
					id: this.generateUuid(),
					presentationId: null,
					startDate: date,
					startTime: hour,
					endTime: null,
					frequencyCode: null,
					duration: null,
					endDate: null,
					timeZone: this.timeZone
				}

			}

		},
		openedEntryDialog () {
			this.$refs.entryForm.clearValidate()
		},
		closeEntryDialog () {
			this.dialog.entry = false
			this.dialog.error = false
			this.processing.update = false
			this.processing.delete = false
		},
		closedEntryDialog () {
			this.existingEntry = false
			this.$refs.entryForm.clearValidate()
		},
		processEntry (date, hour, item) {
			return (
				(
					item.frequencyCode === 0
					&& item.startDate === date
				)
				||
				(
					item.frequencyCode === 1
					&& item.startDate <= date
					&& (item.duration === 0 || item.endDate >= date)
				)
				||
				(
					item.frequencyCode === 2
					&& item.startDate <= date
					&& ((new Date(date).getTime() - new Date(item.startDate).getTime()) / (1000 * 3600 * 24)) % 2 === 0
					&& (item.duration === 0 || item.endDate >= date)
				)
				||
				(
					item.frequencyCode === 3
					&& item.startDate <= date
					&& (item.duration === 0 || item.endDate >= date)
					&& new Date(item.startDate).getDay() === new Date(date).getDay()
				)
				||
				(
					item.frequencyCode === 4
					&& item.startDate <= date
					&& (item.duration === 0 || item.endDate >= date)
					&& new Date(date).getDay() <= 5 && new Date(date).getDay() > 0
				)
				||
				(
					item.frequencyCode === 5
					&& item.startDate <= date
					&& (item.duration === 0 || item.endDate >= date)
					&& (new Date(date).getDay() === 6 || new Date(date).getDay() === 0)
				)
			)
		},
		findEntry (date, hour) {
			const entryIndex = this.schedule.calendarEntries.findIndex(item =>
				item.startTime === hour
				&& this.processEntry(date, hour, item)
			)
			if (entryIndex > -1) {
				return this.schedule.calendarEntries[entryIndex]
			}
		},
		matchEntry (date, hour, arrayEntries) {
			const entryIndex = arrayEntries.findIndex(item =>
				hour >= item.startTime
				&& hour < item.endTime
				&& this.processEntry(date, hour, item)
			)
			return entryIndex > -1
		},
		checkEntry () {
			if (this.schedule.calendarEntries.length) {

				const period = this.entry.duration === 1 ? ((new Date(this.entry.endDate).getTime() - new Date(this.entry.startDate).getTime()) / (1000 * 3600 * 24)) : this.defaultPeriod
				const tempDate = new Date(this.entry.startDate)
				let tempEntry = []
				tempEntry.push(this.entry)
				const tempArray = this.entry.id ? this.clone(this.schedule.calendarEntries).filter(item => item.id !== this.entry.id) : this.schedule.calendarEntries

				for (let i = 0; i < period; i++) {
					let date = this.calculateDate(new Date().setDate(tempDate.getDate() + i))
					for (let j = 0; j <= 23; j++) {
						let hour = (j < 10 ? '0' + j : j) + ':00'
						if (this.matchEntry(date, hour, tempArray) && this.matchEntry(date, hour, tempEntry)) {
							this.dialog.error = true
							return
						}
					}
				}

			}
			this.ajaxUpdateEntry()
		},
		findPresentation (id) {
			return this.presentations.find(item => item.id === id)
		},
		back () {
			this.$router.go(-1)
		},
		openAssignDialog () {
			this.dialog.assign = true
		},
		closeAssignDialog () {
			this.dialog.assign = false
			this.processing.assign = false
		}

	}
}
</script>

<style lang="scss" scoped>
.schedule {

	&-navigation {

		@include flex(flex, row, wrap, space-between, center);
		font-size: $font-size + 2;
		font-weight: $font-weight-medium;
		margin-bottom: 20px;

		&-title {

			color: $color-1;

			@include breakpoint(sm) {
				margin-bottom: 20px;
				margin-left: 0;
				width: 100%;
			}

		}

	}

	&-head {

		background: $color-background;
		border: 1px solid darken($color-background, 6%);
		border-right: 0;
		border-radius: 5px 5px 0 0;
		@include flex(flex, row, wrap, flex-start, center);

		&-day {
			border-right: 1px solid darken($color-background, 6%);
			color: lighten($color-text, 25%);
			@include flex(flex, row, wrap, center, center);
			font-size: $font-size - 1;
			font-weight: $font-weight-semibold;
			height: 38px;
			text-align: center;
			user-select: none;
			width: calc(100% / 8);
		}

	}

	&-body {

		border-left: 1px solid darken($color-background, 6%);
		height: calc(100vh - 330px);
		@include flex(flex, row, wrap, flex-start, center);
		overflow-y: auto;

		&-day {

			border-right: 1px solid darken($color-background, 6%);
			color: lighten($color-text, 20%);
			width: calc(100% / 8);

			&-cell {

				border-bottom: 1px solid darken($color-background, 6%);
				@include flex(flex, row, wrap, center, center);
				font-size: $font-size - 1;
				height: 38px;
				position: relative;
				user-select: none;
				transition: background-color .3s ease;

				&.active {

					cursor: crosshair;

					&:hover {
						background: darken($color-background, 6%);
					}

				}

				&.disabled {

					background-color: lighten($color-background, 1%);
					cursor: no-drop;

					.schedule-body-day-cell-entry {
						background-color: darken($color-background, 5%) !important;
						border: 1px solid darken($color-background, 10%);
						color: darken($color-background, 35%);
						cursor: no-drop;
					}

				}

				&-hour {
					background-color: #fff;
					color: lighten($color-text, 35%);
					display: inline-block;
					font-weight: $font-weight-medium;
					padding: 3px 12px;
					position: relative;
					transform: translateY(-20px);
				}

				&-entry {

					border-radius: 4px;
					color: #fff;
					cursor: pointer;
					height: 38px;
					padding: 5px 10px 0 10px;
					@include position($position: absolute, $top: 0, $left: 0);
					transition: background-color .3s ease;
					width: 100%;
					z-index: 2;

					&-title {
						font-weight: $font-weight-medium;
						line-height: 1.15;
						@include text-truncate;
					}

					&-time {
						font-size: 11px;
						line-height: 1.3;
						@include text-truncate;
					}

				}

			}

		}

	}

}
</style>
